import React from "react";
import { Grid } from "@material-ui/core";
import { useFormikContext } from "formik";
import moment from "moment";
import {asDbDateFormat, DATE_FORMAT_DOB_SAVE} from "../../../../../utils/dateUtils";
import {
    TextFieldCommon,
    ErrorCommon,
    TextField,
    DatePicker,
    SelectField,
} from "../../../../../components/formikFormInputs";
import { Label } from "../../../../../components/formInputs";
import { dateFormat } from "highcharts";
import { stateDropDown } from "../../../../../constants";
import { noop } from "../../../../../utils/commonUtils";

const IdDocument = () => {
    const {
        values,
        errors,
        touched,
        setFieldValue,
        handleChange,
        handleBlur,
        setFieldTouched
    } = useFormikContext<any>();

    const [expiryDate, setExpiryDate] = React.useState<any>(null);

    const fields = [
        {
            name: "identityId",
            helperFieldText: "Must be a valid drivers license",
            label: <Label label={values.documentSubType == "Drivers License" ? "Enter drivers license number" : "Enter passport number"} required={true}/>,
            isRequired: true,
            className: "mt35 TextFieldWidth",
            filedType: "string",
            component: TextField,
            size:12,
            variant: "outlined",
        },
        {
            id: "expiry",
            label: <Label label={"Expiry Date"} required={true} />,
            isRequired: true,
            placeholder: "Expiry Date",
            component: DatePicker,
            disablePast: true,
            className: "fullWidthcustomFields",
            errMsg:"proofExpiryMonth",
            field: { value: expiryDate },
            defaultDateFormat: "MM/dd/yy",
            cb: async (val: any) => {
                if (val) {
                    setExpiryDate(val);
                    const dob: any = asDbDateFormat(val, DATE_FORMAT_DOB_SAVE);
                    const year = moment(dob, DATE_FORMAT_DOB_SAVE).year()
                    const month = moment(dob, DATE_FORMAT_DOB_SAVE).month()
                    if(typeof setFieldValue == "function") {
                        setFieldValue("proofExpiryMonth", (Number(month) + 1))
                        setFieldValue("proofExpiryYear", year)
                        setFieldTouched("proofExpiryMonth", true)
                        setFieldTouched("proofExpiryYear", true)
                    }
                }
            }
        },
        {
            component: SelectField,
            label: <Label label={'State'} required={true}/>,
            name: 'employeeIdState',
            onSelectChange: noop,
            options: stateDropDown.map(x => ({...x, id: x.value})),
            size: 12,
            variant: 'outlined',
        }
    ]

    return (
            <>
                {fields.map((field: any, index: number) => (
                        <Grid item xs={field.size || 12} key={index}>
                            <TextFieldCommon
                                    {...field}
                                    values={values}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    onClose={() => {}}
                                    options={field.options}
                            />
                            {(field.name || field.errMsg) && (
                                    <ErrorCommon
                                            errors={errors}
                                            name={field.errMsg || field.name}
                                            touched={touched}
                                    />
                            )}
                        </Grid>
                ))}
            </>
    );

};

export default IdDocument;
